var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmexTransaction = function SvgAmexTransaction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0v20h20V0Z",
    fill: "#1D1737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v20h20v-3.16h-2.76l-1.02-1.193-1.06 1.193H7.32v-6.353H4.733l3.234-7.32h3.146l.76 1.66v-1.66h3.907l.653 1.74.64-1.74H20V0H0Zm17.74 4.2-1.027 2.707-.273.733-.28-.733L15.127 4.2h-2.26v5.334h1.36V6.06l-.007-.7.267.7 1.3 3.474h1.293l1.307-3.474.253-.693v4.167H20V4.2h-2.26Zm-9.04 0L6.34 9.534h1.546L8.3 8.507h2.587l.413 1.027h1.567L10.52 4.2H8.7Zm.626 1.807.267-.667.267.667.553 1.346h-1.64l.553-1.346Zm8.52 4.487L16.24 12.22l-1.6-1.726H8.413v5.313h4.454v-1.153H9.773v-.927h3.034V12.58H9.773v-.933h3.094v-1.153l2.486 2.666-2.486 2.647h1.72l1.62-1.733 1.613 1.733h1.766l-2.493-2.667 2.493-2.646h-1.74Zm.647 2.64L20 14.667V11.62l-1.507 1.514Z",
    fill: "#fff"
  })));
};
export default SvgAmexTransaction;